import { FC } from 'react';

const SuccessIcon: FC = () => {
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M43.2008 24C43.2008 34.6039 34.6046 43.2 24.0008 43.2C13.3969 43.2 4.80078 34.6039 4.80078 24C4.80078 13.3962 13.3969 4.80005 24.0008 4.80005C27.0132 4.80005 29.8635 5.49378 32.4008 6.73021M39.6008 12L22.8008 28.8L18.0008 24"
        stroke="#17996A"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export { SuccessIcon };
